import React from "react"
import PropTypes from "prop-types"
import { Stack, Text, Grid, Container } from "datastory-shared/ui"
import { SocialMediaItem } from "datastory-shared/sections"

export const ShareArticle = ({ alignItems = "center", title }) => {
  return (
    <Stack alignItems={alignItems}>
      {title && <Text muted>{title}</Text>}
      <Container maxW="container.sm" w="100%">
        <Grid variant="simple" columns={3} mt={"md"}>
          <SocialMediaItem iconSize="3rem" type="twitter" disableText={true} />
          <SocialMediaItem iconSize="3rem" type="facebook" disableText={true} />
          <SocialMediaItem iconSize="3rem" type="email" disableText={true} />
        </Grid>
      </Container>
    </Stack>
  )
}

ShareArticle.propTypes = {
  title: PropTypes.string,
  alignItems: PropTypes.string,
}
